exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h2[data-v-4b9403b4]{margin-bottom:1.5rem;margin-top:2.5rem}", ""]);

// exports
